module.exports = __webpack_public_path__ + "img/ah.2f10e26c.png";